export const customDomainHeaderTypes = ['sidebar', 'top'] as const
export type CustomDomainHeaderType = typeof customDomainHeaderTypes[number]

export const customDomainHeaderDisplays = ['always', 'home', 'never'] as const
export type CustomDomainHeaderDisplay =
  typeof customDomainHeaderDisplays[number]

export const textStyles = [
  'cards',
  'textShadow',
  'scrim',
  'glass',
  'outline',
] as const
export type TextStyle = typeof textStyles[number]

export const customDomainHeaderTitleTypes = [
  'guildName',
  'teamDescription',
  'teamName',
  'none',
] as const
export type CustomDomainHeaderTitleType =
  typeof customDomainHeaderTitleTypes[number]

export type CustomDomainHeaderConfig = Partial<{
  headerType: CustomDomainHeaderType
  headerDisplay: CustomDomainHeaderDisplay
  textStyle: TextStyle
  transparentCards: boolean
  titleType: CustomDomainHeaderTitleType
  subtitleType: CustomDomainHeaderTitleType
  noImage: boolean
  height: number
  backgroundImage: string
  hideBanner: boolean
  hideLinks: boolean
  hideOverviewMenuItem: boolean
}>
